import { render, staticRenderFns } from "./secondspes.vue?vue&type=template&id=3b4499ef"
import script from "./secondspes.vue?vue&type=script&lang=js"
export * from "./secondspes.vue?vue&type=script&lang=js"
import style0 from "./secondspes.vue?vue&type=style&index=0&id=3b4499ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports